import { readPipelineState } from "./salaryTemplatePipeline";

export function buildFormulaOverridesFromPipeline(state = readPipelineState()) {
  const out = {};
  const formulas = state.formulas || {};
  for (const [id, row] of Object.entries(formulas)) {
    const expr = String(row?.expression || "").trim();
    if (expr) out[id] = expr;
  }
  return out;
}

export function formatInr(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "—";
  return `₹${n.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

export function ctcStatusTone(status) {
  if (status === "balanced") return "good";
  if (status === "under") return "warn";
  if (status === "over") return "bad";
  return "neutral";
}
